export const returnNonNull = <T>(item: T): item is NonNullable<T> => item !== null;

export const getUniqueValues = <T>(values: T[]): T[] => {
	return Array.from(new Set(values));
};

export const toStringArray = (value?: string[] | string | null): string[] => {
	if (!value) {
		return [];
	}

	return Array.isArray(value) ? value : [value];
};

export const getFirstStringValue = (value?: string[] | string | null): string => {
	return toStringArray(value)[0] ?? '';
};

export type ArrayElement<ArrayType extends readonly unknown[]> =
	ArrayType extends readonly (infer ElementType)[] ? ElementType : never;
